export class GameConstants {

    public static readonly VERSION = "0.0";
    public static readonly DEBUG_MODE = false;
    public static readonly VERBOSE = false;
    public static readonly GAME_WIDTH = 768;
    // public static readonly GAME_HEIGHT = 1024;
    public static readonly GAME_HEIGHT = 1365;
    public static readonly FEE_IN_WAX = "10.00000000";
    public static readonly MAX_TIME_DUELS = 3600;
    public static readonly MONTH_NAMES = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

    public static readonly SAVED_GAME_DATA_KEY = "candy-fiesta";
}
